import styled from 'styled-components';
import { Typography, Tag, Divider } from 'antd';
import { MenuItem as MenuItemBase } from '@app/components/common/Menu/Menu';
import { media } from '@app/styles/themes/constants';

export const ProfileBlock = styled.div`
  max-width: 260px;
`;

export const Name = styled(Typography.Text)`
  font-weight: 600;
  display: block;
  margin-bottom: 4px;
`;

export const Email = styled(Typography.Text)`
  font-size: 12px;
  display: block;
`;

export const Username = styled(Typography.Text)`
  font-size: 11px;
  color: #888;
  display: block;
`;

export const Roles = styled.div`
  margin-top: 6px;
`;

export const RoleTag = styled(Tag)`
  margin-bottom: 4px;
`;

export const Text = styled(Typography.Text)`
  font-size: 0.875rem;
  font-weight: 600;
  & > a {
    display: block;
  }
  @media only screen and ${media.md} {
    font-size: 1rem;
  }
`;

export const MenuItem = styled(MenuItemBase)`
  height: 50px;
`;

export const ItemsDivider = styled(Divider).withConfig({
  shouldForwardProp: (prop) => !['eventKey', 'warnKey'].includes(prop),
})`
  margin: 0;
`;
